export default __webpack_public_path__ + "static/media/file-lock-outline.01d64a8a.svg";